import { gql } from "@apollo/client";

export const USER_ACTIVITY = gql`
  query UserActivity(
    $where: UserActivityWhereInput
    $like: UserActivityWhereInput
    $take: Int
    $skip: Int
    $isIn: JSONObject
    $custom: JSONObject
    $orderBy: [JSONObject]
  ) {
    userActivities(
      where: $where
      take: $take
      skip: $skip
      like: $like
      custom: $custom
      isIn: $isIn
      orderBy: $orderBy
    ) {
      data {
        id
        module
        action
        status
        critical
        createdDate
        updatedDate
        data
        user {
          id
          firstname
          lastname
        }
        process {
          id
        }
      }
      count
    }
  }
`;

const userActivity = { USER_ACTIVITY };

export default userActivity;
